export const WIDGETS = "widgets";
export const WIDGETS_LOGBOOKS = `log-book`;
